module.exports = __webpack_public_path__ + "img/png.a71882e8.svg";